import { Link } from 'react-router-dom';

const footerLinks = {
  explore: [
    { name: '最新电影', path: '/category/all' },
    { name: '热映大片', path: '/category/all' },
    { name: '经典老片', path: '/category/all' },
    { name: '电影排行榜', path: '/category/all' },
  ],
  categories: [
    { name: '科幻电影', path: '/category/scifi' },
    { name: '动作电影', path: '/category/action' },
    { name: '喜剧电影', path: '/category/comedy' },
    { name: '悬疑电影', path: '/category/suspense' },
    { name: '爱情电影', path: '/category/romance' },
    { name: '动画电影', path: '/category/animation' },
  ],
  about: [
    { name: '关于我们', path: '/about' },
    { name: '品牌故事', path: '/about' },
    { name: '联系方式', path: '/about' },
    { name: '用户口碑', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300/40">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl font-bold text-primary-500">
              陌陌影视
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              电影大全提供最新电影、热映大片、经典老片和电影排行榜，高清画质免费在线观看，资源丰富每日更新，极速播放不卡顿。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-300/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-300/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-300/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-100 mb-4">探索发现</h3>
            <ul className="flex flex-col gap-2">
              {footerLinks.explore.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-100 mb-4">电影分类</h3>
            <ul className="flex flex-col gap-2">
              {footerLinks.categories.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-semibold text-foreground-100 mb-4">关于陌陌</h3>
            <ul className="flex flex-col gap-2">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5">
              <p className="text-sm text-foreground-400">客服邮箱</p>
              <p className="text-sm text-foreground-200 mt-1">service@momomovies.com</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-300/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 陌陌影视 版权所有 | 高清电影免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}